// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s-cte-pneu {
  height: 80px;
  cursor: pointer;
  opacity: 0.3;
  position: relative;
  margin-top: 10px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
}

.s-cte-pneu > label {
  top: calc(50% - 10px);
  left: 2px;
  width: 32px;
  color: white;
  cursor: pointer;
  display: inline-block;
  position: absolute;
  font-size: 10px;
  max-width: 35px;
  word-wrap: break-word;
  text-align: center;
  line-height: normal;
  font-weight: bold;
}

.s-cte-pneu > img {
  top: -10px;
  height: 100px;
  position: relative;
  transform: rotateX(40deg);
  border-radius: 4px;
}

.s-cte-pneu .s-ctr-pneu-status {
  top: -5px;
  right: -2px;
  color: white;
  width: 21px;
  height: 20px;
  border: 1px solid white;
  position: absolute;
  font-size: 10px !important;
  text-align: center;
  line-height: normal;
  border-radius: 50%;
  background-color: darkgreen;
}

.s-cte-pneu .s-ctr-pneu-status i {
  top: 2px;
  position: relative;
  font-size: 1.3em !important;
}

.s-cte-pneu-bold {
  opacity: 1 !important;
}

@keyframes s-cte-pneu-swing {
  15% {
    transform: translateX(5px);
  }

  30% {
    transform: translateX(-5px);
  }

  50% {
    transform: translateX(3px);
  }

  65% {
    transform: translateX(-3px);
  }

  80% {
    transform: translateX(2px);
  }

  100% {
    transform: translateX(0);
  }
}

.cte-veiculo-estrutura {
  width: 230px;
  margin: 0 auto;
  position: relative;
  /*transform: scale(0.9);*/
}

.cte-veiculo-estrutura-limites {
  width: 100%;
  height: 5px;
  border: 1px solid #000;
  background-color: #aaa;
}

.cte-veiculo-estrutura-chassi {
  top: 6px;
  left: calc(50% - 30px);
  width: 5px;
  float: left;
  border: 1px solid #000;
  height: calc(100% - 14px);
  position: absolute;
  background-color: #aaa;
}

.cte-veiculo-estrutura-chassi2 {
  left: calc(50% + 20px);
}

.cte-veiculo-estrutura-eixo {
  width: 100%;
  height: 80px;
  margin: 0 0 30px 0;
  position: relative;
}

.cte-veiculo-estrutura-risco {
  top: 50%;
  width: 100%;
  height: 1px;
  border: 1px solid #000;
  position: absolute;
  background-color: #ccc;
}

.cte-veiculo-estrutura-eixo2 {
  width: 100%;
  margin: 0;
  height: 80px;
  position: relative;
}

.cte-veiculo-estrutura-eixo-label {
  top: 20px;
  left: calc(50% - 10px);
  position: absolute;
}

.cte-veiculo-estrutura-estepe1 {
  left: 30px;
  bottom: -60px;
  cursor: pointer;
  position: absolute;
  transform: rotate(-90deg);
  max-width: 80px;
  max-height: 80px;
}

.cte-veiculo-estrutura-estepe2 {
  right: 50px;
  bottom: -60px;
  cursor: pointer;
  position: absolute;
  transform: rotate(-90deg);
  max-width: 80px;
  max-height: 80px;
}

.cte-veiculo-estrutura-estepe-bottom label {
  top: calc(50% - 5px) !important;
  left: -6px !important;
  width: 50px !important;
  transform: rotate(90deg);
  max-width: 50px !important;
}

.cte-veiculo-estrutura-pneu-oculto {
  display: none;
}

.cte-veiculo-estrutura-pneu-bold {
  opacity: 1 !important;
}

.cte-veiculo-estrutura-E2 {
  top: -11px;
  cursor: pointer;
  position: absolute;
  margin-left: 5px;
}

.cte-veiculo-estrutura-E1 {
  top: -11px;
  cursor: pointer;
  position: absolute;
  margin-left: 40px;
}

.cte-veiculo-estrutura-D1 {
  top: -11px;
  cursor: pointer;
  position: absolute;
  margin-left: 155px;
}

.cte-veiculo-estrutura-D2 {
  top: -11px;
  cursor: pointer;
  position: absolute;
  margin-left: 190px;
}
`, "",{"version":3,"sources":["webpack://./frontend/components/cte/style.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".s-cte-pneu {\n  height: 80px;\n  cursor: pointer;\n  opacity: 0.3;\n  position: relative;\n  margin-top: 10px;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n}\n\n.s-cte-pneu > label {\n  top: calc(50% - 10px);\n  left: 2px;\n  width: 32px;\n  color: white;\n  cursor: pointer;\n  display: inline-block;\n  position: absolute;\n  font-size: 10px;\n  max-width: 35px;\n  word-wrap: break-word;\n  text-align: center;\n  line-height: normal;\n  font-weight: bold;\n}\n\n.s-cte-pneu > img {\n  top: -10px;\n  height: 100px;\n  position: relative;\n  transform: rotateX(40deg);\n  border-radius: 4px;\n}\n\n.s-cte-pneu .s-ctr-pneu-status {\n  top: -5px;\n  right: -2px;\n  color: white;\n  width: 21px;\n  height: 20px;\n  border: 1px solid white;\n  position: absolute;\n  font-size: 10px !important;\n  text-align: center;\n  line-height: normal;\n  border-radius: 50%;\n  background-color: darkgreen;\n}\n\n.s-cte-pneu .s-ctr-pneu-status i {\n  top: 2px;\n  position: relative;\n  font-size: 1.3em !important;\n}\n\n.s-cte-pneu-bold {\n  opacity: 1 !important;\n}\n\n@keyframes s-cte-pneu-swing {\n  15% {\n    transform: translateX(5px);\n  }\n\n  30% {\n    transform: translateX(-5px);\n  }\n\n  50% {\n    transform: translateX(3px);\n  }\n\n  65% {\n    transform: translateX(-3px);\n  }\n\n  80% {\n    transform: translateX(2px);\n  }\n\n  100% {\n    transform: translateX(0);\n  }\n}\n\n.cte-veiculo-estrutura {\n  width: 230px;\n  margin: 0 auto;\n  position: relative;\n  /*transform: scale(0.9);*/\n}\n\n.cte-veiculo-estrutura-limites {\n  width: 100%;\n  height: 5px;\n  border: 1px solid #000;\n  background-color: #aaa;\n}\n\n.cte-veiculo-estrutura-chassi {\n  top: 6px;\n  left: calc(50% - 30px);\n  width: 5px;\n  float: left;\n  border: 1px solid #000;\n  height: calc(100% - 14px);\n  position: absolute;\n  background-color: #aaa;\n}\n\n.cte-veiculo-estrutura-chassi2 {\n  left: calc(50% + 20px);\n}\n\n.cte-veiculo-estrutura-eixo {\n  width: 100%;\n  height: 80px;\n  margin: 0 0 30px 0;\n  position: relative;\n}\n\n.cte-veiculo-estrutura-risco {\n  top: 50%;\n  width: 100%;\n  height: 1px;\n  border: 1px solid #000;\n  position: absolute;\n  background-color: #ccc;\n}\n\n.cte-veiculo-estrutura-eixo2 {\n  width: 100%;\n  margin: 0;\n  height: 80px;\n  position: relative;\n}\n\n.cte-veiculo-estrutura-eixo-label {\n  top: 20px;\n  left: calc(50% - 10px);\n  position: absolute;\n}\n\n.cte-veiculo-estrutura-estepe1 {\n  left: 30px;\n  bottom: -60px;\n  cursor: pointer;\n  position: absolute;\n  transform: rotate(-90deg);\n  max-width: 80px;\n  max-height: 80px;\n}\n\n.cte-veiculo-estrutura-estepe2 {\n  right: 50px;\n  bottom: -60px;\n  cursor: pointer;\n  position: absolute;\n  transform: rotate(-90deg);\n  max-width: 80px;\n  max-height: 80px;\n}\n\n.cte-veiculo-estrutura-estepe-bottom label {\n  top: calc(50% - 5px) !important;\n  left: -6px !important;\n  width: 50px !important;\n  transform: rotate(90deg);\n  max-width: 50px !important;\n}\n\n.cte-veiculo-estrutura-pneu-oculto {\n  display: none;\n}\n\n.cte-veiculo-estrutura-pneu-bold {\n  opacity: 1 !important;\n}\n\n.cte-veiculo-estrutura-E2 {\n  top: -11px;\n  cursor: pointer;\n  position: absolute;\n  margin-left: 5px;\n}\n\n.cte-veiculo-estrutura-E1 {\n  top: -11px;\n  cursor: pointer;\n  position: absolute;\n  margin-left: 40px;\n}\n\n.cte-veiculo-estrutura-D1 {\n  top: -11px;\n  cursor: pointer;\n  position: absolute;\n  margin-left: 155px;\n}\n\n.cte-veiculo-estrutura-D2 {\n  top: -11px;\n  cursor: pointer;\n  position: absolute;\n  margin-left: 190px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
